export default __webpack_public_path__ + "static/media/medical vector_.3e8b94af.jpg";